var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M12.8926 9.80273H18.3471"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M15.438 6.36523L18.876 9.80325L15.438 13.2413"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M7.80176 9.80273H2.34721"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M5.25635 6.36523L1.81833 9.80325L5.25635 13.2413"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M9.2561 2.72852V17.274"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 1.2,
    d: "M11.438 2.72852V17.274"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluid);
export default __webpack_public_path__ + "static/media/fluid.0362f7510633b47701be1438e344144b.svg";
export { ForwardRef as ReactComponent };